import React from 'react';
import { useAiCommentAction } from 'hooks/useAiCommentAction';
import styled, { css } from 'styled-components';
import GptIcon from 'components/Icons/gpt.svg';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';

const disabledCss = css`
  opacity: 0.7;
  pointer-events: none;
`;

const AiButton = styled.div<{ bg: string; disabled: boolean }>`
  margin-left: auto;
  height: 24px;
  background: ${props => props.bg};
  border-radius: 8px;
  cursor: pointer;

  color: #fff;
  font-size: 12px;
  line-height: 16px;
  padding: 4px 12px;

  ${props => props.disabled && disabledCss}
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

type Props = {
  fieldId: string;
  noLabel?: boolean;
};

export const AiNotesDialogComponent: React.FC<Props> = ({ fieldId, noLabel = false }: Props) => {
  const { buttonLabel, buttonColor, action, status } = useAiCommentAction(fieldId);
  const { hasAnotherEditor } = useVehicleEditing();
  if (status === 'ai_used') return null;
  return (
    <Wrapper>
      {status === 'ai_fetched' && !noLabel && <AiGeneratedLabelComponent />}
      <AiButton disabled={hasAnotherEditor} bg={buttonColor} onClick={action}>
        {buttonLabel}
      </AiButton>
    </Wrapper>
  );
};

const AiGeneratedTextLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  color: #000;
`;

const AiGeneratedLabelComponent = () => {
  return (
    <>
      <GptIcon />
      <AiGeneratedTextLabel>AI generated Text</AiGeneratedTextLabel>
    </>
  );
};
